import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import Modal from 'components/new_ui/Modal/Modal';
import Table from 'components/new_ui/Table';

export default function StatisticModal({
  show, title, columns, data, defaultSortFieldId, onCloseClick,
}) {
  return (
    <Modal show={show} size="lg">
      <Table
        title={title}
        columns={columns}
        defaultSortFieldId={defaultSortFieldId}
        data={data || []}
        loading={data === null}
        selectableRows={false}
      />

      <footer>
        <Button
          variant="outline-primary"
          className="btn-reverse"
          onClick={onCloseClick}
        >
          Close
        </Button>
      </footer>
    </Modal>
  );
}

StatisticModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  defaultSortFieldId: PropTypes.number,
  onCloseClick: PropTypes.func.isRequired,
};

StatisticModal.defaultProps = {
  data: null,
  defaultSortFieldId: undefined,
};
